import { Link, useMatch, useResolvedPath } from "react-router";

export default function DLink({ to, children, className, ...props}) {
    const resolvedPath = useResolvedPath(to);
    const isActive = useMatch({path:resolvedPath.pathname, end:true});
    return (
        <Link className={className+(isActive?" navbar-selected":"")} to={to} {...props}>{children}</Link>
    )
}